import React from 'react'
import Box from '@mui/material/Box'

const Spacer = ({ size = null }) => <Box sx={{ my: size ? size : 10 }} />

export default Spacer
